import React from "react";

const ListData = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 20.534h5.333v-5.511L2 15.022v5.512ZM2 9.51h5.333V4H2v5.511Zm0 22.045h5.333v-5.511H2v5.51Zm10.667-11.022H34v-5.511l-21.333-.001v5.512Zm0-11.023H34V4H12.667v5.511Zm0 22.045H34v-5.511H12.667v5.51Z"
            fill={fill}
        />
    </svg>
);

export default ListData;